const Custom = {
  install (Vue, options) {
    Vue.mixin({
      created: function () {
      },
      methods: {
        numberFormat: function (number, format) {
          return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, format)
        },
        errorMessage: function (error) {
          this.$geb.emit({id: 'preloader', eventData: false})
          if (error.message === 'Network Error') {
            this.$geb.emit({id: 'alert_modal', title: 'Network Error', content: 'You are not connected to Internet', button_text: 'OK'})
          } else {
            this.$geb.emit({id: 'alert_modal', title: 'Oops...', content: 'Ada masalah pada sistem, mohon hubungi connections.jpcc@gmail.com untuk melaporkan masalah ini. Terima kasih', button_text: 'OK'})
            console.log(error)
          }
        }
      }
    })
  }
}

export default Custom



// WEBPACK FOOTER //
// ./src/library/Custom.js